'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var index_es = require('./index.es-1f72f6f2.js');
var index$6 = require('./index-ca6c0fa7.js');

(function (PaymentMethodTypes) {
    PaymentMethodTypes["INVOICE"] = "INVOICE";
    PaymentMethodTypes["CREDIT_CARD"] = "credit_card";
    PaymentMethodTypes["APPLE_PAY"] = "APPLE_PAY";
    PaymentMethodTypes["CREDIT_POINTS"] = "CREDIT_POINTS";
})(exports.PaymentMethodTypes || (exports.PaymentMethodTypes = {}));

var PaymentMethodContainer = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  width: auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 22px;\n"], ["\n  width: auto;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 22px;\n"])));
var PaymentMethodContainerForInvoice = styled__default(PaymentMethodContainer)(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  justify-content: flex-start;\n"], ["\n  justify-content: flex-start;\n"])));
var Icon = styled__default(index_es.FontAwesomeIcon)(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  flex: 0 1 auto;\n  color: ", ";\n  margin-right: 22px;\n"], ["\n  flex: 0 1 auto;\n  color: ", ";\n  margin-right: 22px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
});
var Method = styled__default.div(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  font: 400 14px/16.41px ", ";\n  color: ", ";\n  flex: 1 1 auto;\n"], ["\n  font: 400 14px/16.41px ", ";\n  color: ", ";\n  flex: 1 1 auto;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
});
var EditButton = styled__default.div(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n  padding: 5px;\n  flex: 0 1 auto;\n  color: ", ";\n  cursor: pointer;\n\n  &:hover,\n  &:focus {\n    color: ", ";\n  }\n"], ["\n  padding: 5px;\n  flex: 0 1 auto;\n  color: ", ";\n  cursor: pointer;\n\n  &:hover,\n  &:focus {\n    color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.secondary;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.secondary;
});
var InvoiceText = styled__default.div(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n  font: 400 14px/22px ", ";\n  color: ", ";\n  align-self: flex-start;\n"], ["\n  font: 400 14px/22px ", ";\n  color: ", ";\n  align-self: flex-start;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
});
var PayWithCreditsText = styled__default.div(templateObject_7 || (templateObject_7 = tslib_es6.__makeTemplateObject(["\n  font: 400 14px/16px ", ";\n  color: ", ";\n  flex: 1 1 auto;\n"], ["\n  font: 400 14px/16px ", ";\n  color: ", ";\n  flex: 1 1 auto;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.darkGrey7;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;

/* eslint-disable react/require-default-props */
var PaymentMethod = function (_a) {
    var methodText = _a.methodText, className = _a.className, editButtonText = _a.editButtonText, onEditClick = _a.onEditClick, paymentMethod = _a.paymentMethod;
    switch (paymentMethod) {
        case exports.PaymentMethodTypes.INVOICE:
            return (React__default.createElement(PaymentMethodContainerForInvoice, { className: className },
                React__default.createElement(Icon, { icon: index$6.faFileInvoiceDollar, size: "1x" }),
                React__default.createElement(InvoiceText, null, methodText)));
        case exports.PaymentMethodTypes.CREDIT_CARD:
            return (React__default.createElement(PaymentMethodContainer, { className: className },
                React__default.createElement(Icon, { icon: index$6.faCreditCard, size: "1x" }),
                React__default.createElement(Method, null, methodText),
                !!editButtonText && React__default.createElement(EditButton, { onClick: onEditClick }, editButtonText)));
        case exports.PaymentMethodTypes.CREDIT_POINTS:
            return (React__default.createElement(PaymentMethodContainer, { className: className },
                React__default.createElement(Icon, { icon: index$6.faStars, size: "1x" }),
                React__default.createElement(PayWithCreditsText, null, methodText),
                !!editButtonText && React__default.createElement(EditButton, { onClick: onEditClick }, editButtonText)));
        default:
            return null;
    }
};

exports.PaymentMethod = PaymentMethod;
